/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOutOfRangeHigh = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 .586 23.414 12 12 23.414.586 12zM3.414 12 12 20.586 20.586 12 12 3.414zM12 6.586l5.707 5.707-1.414 1.414L13 10.414V17h-2v-6.586l-3.293 3.293-1.414-1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOutOfRangeHigh as OutOfRangeHigh };
